import React from 'react'
import LogoDirecaoBlack from '../../assets/logos/LogosBlackAndWhite/ModeNeutral.svg'
// import LogoDirecao from '../../assets/logos/Direção_2023_Logo_Direção.svg'
import { Container } from './styles'
import Img from 'react-webp-image'
import { RootState } from '../../store/modules/rootReducer'
import { useSelector } from 'react-redux'

const Footer: React.FC = () => {
  const currentTime = new Date()
  const year = currentTime.getFullYear()
  const { isDarkMode } = useSelector((state: RootState) => state.theme)

  return (
    <Container>
      <Img src={LogoDirecaoBlack} alt="Direção Concursos" className="logoDirecao" />
      <p>© Direção Concursos {year} • Todos os direitos reservados</p>
    </Container>
  )
}

export default Footer
